export const marginPadding = {
  auto: 'auto',
  unset: 'unset',
  extraSmall: 8,
  small: 16,
  medium: 24,
  large: 32,
  extraLarge: 48,
  rem0p7: '0.7rem',
  rem1: '1rem',
  empty: 0,
  custom0p25: 0.25,
  custom0p5: 0.5,
  custom0p625: 0.625,
  custom0p75: 0.75,
  custom1: 1,
  custom1rem: '0.0625rem',
  custom1p5: 1.5,
  custom2: 2,
  custom2rem: '0.125rem',
  custom2p5: 2.5,
  custom3: 3,
  custom3rem: '0.1875rem',
  custom3p5: 3.5,
  custom4: 4,
  custom4rem: '0.25rem',
  custom5: 5,
  custom5rem: '0.3125rem',
  custom6: 6,
  custom6rem: '0.375rem',
  custom7: 7,
  custom7rem: '0.4375rem',
  custom7p5: 7.5,
  custom8: 8,
  custom8rem: '0.5rem',
  custom9: 9,
  custom9rem: '0.5625rem',
  custom10: 10,
  custom10rem: '0.625rem',
  custom11: 11,
  custom11rem: '0.6875rem',
  custom11p5: 11.5,
  custom12: 12,
  custom12rem: '0.75rem',
  custom13: 13,
  custom13rem: '0.8125rem',
  custom14: 14,
  custom14rem: '0.875rem',
  custom15: 15,
  custom15rem: '0.9375rem',
  custom15p53: 15.53,
  custom16: 16,
  custom16rem: '1rem',
  custom17: 17,
  custom17rem: '1.0625rem',
  custom18: 18,
  custom18rem: '1.125rem',
  custom19: 19,
  custom19rem: '1.1875rem',
  custom20: 20,
  custom20rem: '1.25rem',
  custom21: 21,
  custom21rem: '1.3125rem',
  custom22: 22,
  custom22rem: '1.375rem',
  custom23: 23,
  custom23rem: '1.4375rem',
  custom24: 24,
  custom24rem: '1.5rem',
  custom25: 25,
  custom25rem: '1.5625rem',
  custom25remNumber: 1.5625,
  custom26: 26,
  custom26rem: '1.625rem',
  custom27: 27,
  custom27rem: '1.6875rem',
  custom28: 28,
  custom28rem: '1.75rem',
  custom29: 29,
  custom29rem: '1.8125rem',
  custom30: 30,
  custom30rem: '1.875rem',
  custom31: 31,
  custom31rem: '1.9375rem',
  custom32: 32,
  custom32rem: '2rem',
  custom33: 33,
  custom33rem: '2.0625rem',
  custom34: 34,
  custom34rem: '2.125rem',
  custom35: 35,
  custom35rem: '2.1875rem',
  custom36: 36,
  custom36rem: '2.25rem',
  custom37: 37,
  custom37rem: '2.3125rem',
  custom38: 38,
  custom38rem: '2.375rem',
  custom39: 39,
  custom40: 40,
  custom40rem: '2.5rem',
  custom41: 41,
  custom42: 42,
  custom42rem: '2.625rem',
  custom43: 43,
  custom44: 44,
  custom44rem: '2.75rem',
  custom45: 45,
  custom45rem: '2.8125rem',
  custom46: 46,
  custom46rem: '2.875rem',
  custom47: 47,
  custom48: 48,
  custom48rem: '3rem',
  custom50: 50,
  custom50rem: '3.125rem',
  custom49: 49,
  custom51: 51,
  custom52: 52,
  custom53: 53,
  custom53rem: '3.3125rem',
  custom54: 54,
  custom54rem: '3.375rem',
  custom55: 55,
  custom55rem: '3.4375rem',
  custom56: 56,
  custom56rem: '3.5rem',
  custom57: 57,
  custom58: 58,
  custom60: 60,
  custom60rem: '3.75rem',
  custom62: 62,
  custom64: 64,
  custom64rem: '4rem',
  custom65: 65,
  custom66: 66,
  custom67: 67,
  custom68: 68,
  custom68rem: '4.25rem',
  custom69: 69,
  custom70: 70,
  custom70rem: '4.375rem',
  custom71: 71,
  custom72: 72,
  custom72rem: '4.5rem',
  custom75: 75,
  custom76: 76,
  custom77: 77,
  custom78: 78,
  custom78rem: '4.875rem',
  custom79: 79,
  custom80: 80,
  custom80rem: '5rem',
  custom81: 81,
  custom84: 84,
  custom84rem: '5.25rem',
  custom85: 85,
  custom85rem: '5.3125rem',
  custom86: 86,
  custom86rem: '5.375rem',
  custom88: 88,
  custom88rem: '5.5rem',
  custom89: 89,
  custom90: 90,
  custom91: 91,
  custom92: 92,
  custom93: 93,
  custom94: 94,
  custom96: 96,
  custom96rem: '6rem',
  custom100: 100,
  custom100rem: '6.25rem',
  custom101: 101,
  custom102: 102,
  custom102rem: '6.375rem',
  custom105: 105,
  custom108: 108,
  custom108rem: '6.75rem',
  custom110: 110,
  custom112: 112,
  custom116: 116,
  custom119rem: '7.4375rem',
  custom120: 120,
  custom120rem: '7.5rem',
  custom121: 121,
  custom123: 123,
  custom125: 125,
  custom128: 128,
  custom130: 130,
  custom131: 131,
  custom137: 137,
  custom140: 140,
  custom141: 141,
  custom144: 144,
  custom150: 150,
  custom150rem: '9.375rem',
  custom151: 151,
  custom152: 152,
  custom154: 154,
  custom160: 160,
  custom160rem: '10rem',
  custom170: 170,
  custom180: 180,
  custom188rem: '11.75rem',
  custom190: 190,
  custom197: 197,
  custom199: 199,
  custom199rem: '12.4375rem',
  custom200: 200,
  custom200rem: '12.5rem',
  custom210: 210,
  custom221: 221,
  custom238: 238,
  custom240: 240,
  custom247rem: '15.4375rem',
  custom248: 248,
  custom250: 250,
  custom270: 270,
  custom280: 280,
  custom294: 294,
  custom299: 299,
  custom300: 300,
  custom344: 344,
  custom700: 700,
  custom902: 902,
  custom0px: '0rem',
  custom1px: '0.0625rem',
  custom2px: '0.125rem',
  custom3px: '0.1875rem',
  custom4px: '0.25rem',
  custom5px: '0.3125rem',
  custom8px: '0.5rem',
  custom10px: '0.625rem',
  custom12px: '0.75rem',
  custom11px: '0.6875rem',
  custom14px: '0.875rem',
  custom15px: '0.9375rem',
  custom16px: '1rem',
  custom17px: '1.0625rem',
  custom20px: '1.25rem',
  custom21px: '1.3125rem',
  custom24px: '1.5rem',
  custom26px: '1.625rem',
  custom28px: '1.75rem',
  custom32px: '2rem',
  custom40px: '2.5rem',
  custom44px: '2.75rem',
  custom46px: '2.875rem',
  custom100px: '6.25rem',
  marginCustom: '1rem',
  percentage3: '3%',
  percentage4: '4%',
  percentage5: '5%',
  percentage10: '10%',
  percentage12: '12%',
  percentage15: '15%',
  percentage18: '18%',
  percentage22p527: '22.527%',
  percentage22p6: '22.6%',
  percentage23: '23%',
  percentage25: '25%',
  percentage25p2: '25.2%',
  percentage31p5: '31.5%',
  percentage34p203: '34.203%',
  percentage34p204: '34.204%',
  percentage34p5: '34.5%',
  percentage35: '35%',
  percentage40: '40%',
  percentage45: '45%',
  percentage45p2: '45.2%',
  percentage46p8: '46.8%',
  percentage47p22: '47.22%',
  percentage47p42: '47.42%',
  percentage50: '50%',
  percentage55: '55%',
  percentage60: '60%',
  percentage90: '90%',
  percentage100: '100%',
  percentage80: '80%',
  percentage85: '85%',
  negativePercentage6p8: '-6.8%',
  negativePercentage4p5: '-4.5%',
  negativePercentage15: '-15%',
  negativePercentage60: '-60%',
  negativePercentage50: '-50%',
  negativePercentage90: '-90%',
  relative35: '2.1875rem',
  relative30: '1.875rem',
  relative45: '2.8125rem',
  drawerWidth: 17.5,
  appBarMobile: 4,
  appBarDesktop: 5.75,
  skillCardPadding: '0.0625rem 0.5rem',
  mainSkillCardPadding: '1rem 0.75rem 1rem 1.5625rem',
  skillCardPaddingSecondary: '0.625rem 0.9375rem',
  commonCardPadding: '0.9375rem 1.5625rem',
  commonCardPaddingSm: '0.9375rem 0.625rem',
  dataLabelsOffset10: -10,
  lineHeight28: '1.75rem',
  marginTitle: '1.875rem 0rem',
  learnerHomeCard: '1.5rem 2rem',
  emptyStateComponentButton: '0.375rem 1rem',
  customNegative2: -2,
  customNegative3: -3,
  customNegative4: -4,
  customNegative5: -5,
  customNegative7: -7,
  customNegative8: -8,
  customNegative8rem: '-0.5rem',
  customNegative9: -9,
  customNegative10: -10,
  customNegative10rem: '-0.625rem',
  customNegative11: -11,
  customNegative12: -12,
  customNegative15: -15,
  customNegative16: -16,
  customNegative18: -18,
  customNegative18rem: '-1.125rem',
  customNegative20: -20,
  customNegative30: -30,
  customNegative32: -32,
  customNegative49: -49,
  customNegative55: -55,
  customNegative78: -78,
  customNegative90: -90,
  customNegative105: -105,
  customNegative144: -144,
  custom4Px: '0.25rem',
  custom12Px: '0.75rem',
  custom100Px: '6.25rem',
  backgroundPaddingBox: 'padding-box',
  quarterRem: '0.25rem',
  halfRem: '0.5rem',
  twoRem: '2rem',
  wizardConnector: {
    left: 'calc(-50% + 1.25rem)',
    right: 'calc(50% + 1.25rem)',
  },
  loginBoxShadowFirst: '0 0 0.125rem',
  loginBoxShadowSecond: '0 1rem 2rem -0.25rem',
  paddingCourseCardsMobile: '1.5rem 0 0 1.5rem',
  chipSelectorPadding: '0 1rem 0.9375rem',
  negative11: '-0.6875rem',
  topListDivRoot: '0rem 1.5625rem',
  topListContainer: '0rem 0rem 1.5rem',
  topListItemFirst: '1rem 0rem 1.5rem',
  roleSelectorPadding: '1.75rem 3rem 1.75rem 3rem',
  topListItem: '0.3125rem 0rem',
  fullNotificationList: '0 !important',
  mobileDrawer: '2rem !important',
  boxShadowItemColumnBoard: '0rem 0rem 0.5625rem',
  boxShadowAddOccupationModal: '0rem 1.25rem 2.5rem -0.25rem',
  floatingErrorWizard: '0.75rem 1rem',
  custom200px: '12.5rem',
  custom400px: '25rem',
  custom18px: '1.125rem',
  metricBadgePadding: '0 0.625rem',
};
